import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { 
  Tabbar, 
  TabbarItem,
  NavBar,
  Card,
  Button,
  Image as VanImage,
  Swipe,
  SwipeItem,
  Tab,
  Tabs,
  Grid,
  GridItem,
  Icon,
  Badge,
  Form,
  Field,
  CellGroup,
  Cell,
  Checkbox,
  CheckboxGroup,
  Tag,
  Empty,
  Loading,
  Dialog,
  Radio,
  RadioGroup,
  Picker,
  Popup,
  Switch as VanSwitch
} from 'vant'
import 'vant/lib/index.css'

const app = createApp(App)

// 注册Vant组件
app.use(Tabbar)
app.use(TabbarItem)
app.use(NavBar)
app.use(Card)
app.use(Button)
app.use(VanImage)
app.use(Swipe)
app.use(SwipeItem)
app.use(Tab)
app.use(Tabs)
app.use(Grid)
app.use(GridItem)
app.use(Icon)
app.use(Badge)
app.use(Form)
app.use(Field)
app.use(CellGroup)
app.use(Cell)
app.use(Checkbox)
app.use(CheckboxGroup)
app.use(Tag)
app.use(Empty)
app.use(Loading)
app.use(Dialog)
app.use(Radio)
app.use(RadioGroup)
app.use(Picker)
app.use(Popup)

// 全局禁用输入框缩放
const preventZoom = {
  mounted() {
    // 创建或更新viewport meta标签
    let viewportMeta = document.querySelector('meta[name="viewport"]')
    if (!viewportMeta) {
      viewportMeta = document.createElement('meta')
      viewportMeta.name = 'viewport'
      document.head.appendChild(viewportMeta)
    }
    viewportMeta.content = 'width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no'
    
    // 添加全局事件监听器，在输入框获得焦点时阻止缩放
    document.addEventListener('focus', (e) => {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT') {
        // 确保viewport设置正确
        viewportMeta.content = 'width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no'
      }
    }, true)
  }
}

app.directive('prevent-zoom', preventZoom)
app.mixin({
  mounted() {
    preventZoom.mounted()
  }
})

// 使用路由
app.use(router)

app.component('van-switch', VanSwitch)

app.mount('#app')
